import styles from './FAQ.module.css';
import useInView from '../Animation/useInView.ts';
import { FAQ } from '../../services/api/types.ts';
import { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { IconLibrary } from '../common/Icons.tsx';
import { ReactNode } from 'react';

interface FAQProps {
  title?: string;
  subtitle?: string;
  items: FAQ[];
  className?: string;
}

const FAQP = ({
  title = "Часто задаваемые вопросы",
  subtitle,
  items,
  className = ""
}: FAQProps) => {
  const { ref, isInView } = useInView({ threshold: 0.1, triggerOnce: true });

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleQuestion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="FAQ" ref={ref} className={`${styles.faq} ${className}${isInView ? styles.visible : ''}`}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>

        <div className={styles.grid}>
          {items.map((item, index) => {
            const Icon = IconLibrary[item.IconIndex ?? (index % IconLibrary.length)];

            return (

              <div
                key={index}
                className={`${styles.card} ${openIndex === index ? styles.open : ''}`}
                style={{ '--i': index } as React.CSSProperties}
                onClick={() => toggleQuestion(index)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && toggleQuestion(index)}
              >
                <div className={styles.questionWrapper}>
                  {Icon && <div className={styles.icon}>{<Icon />}</div>}
                  <h3 className={styles.question}>{item.Question}</h3>
                  <span className={`${styles.toggleIcon} ${openIndex === index ? styles.toggleOpen : ''}`}>
                    <FaChevronDown />
                  </span>
                </div>

                <div className={`${styles.answer} ${openIndex === index ? styles.answerOpen : ''}`}>
                  <p>{item.Answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQP;
